import { SET_FILTER_COUNT, SET_CURRENT_FILTER } from "../action-types/archiveFilter"

export const setArchiveFilterCount = (count) => (dispatch) => {
    dispatch({
        type: SET_FILTER_COUNT,
        payload: count,
    })
}

export const setCurrentArchiveFilter = (currentValue) => (dispatch) => {
    dispatch({
        type: SET_CURRENT_FILTER,
        payload: currentValue,
    })
}
